<template>
    <div class="product-image">

        <div class="badges" v-if="badges && badges.length">
            <span class="badge"
                  v-for="(badge, key) in badges"
                  :key="key"
                  :style="{ backgroundColor: badge.color, color: badge.text_color }"
            >
                {{ badge.name }}
            </span>
        </div>

        <figure>
            <img :src="image"
                 loading="lazy"
                 :alt="name"
                 @click="lightboxVisible = true; imgIndex = 0"
            >
        </figure>

        <vue-easy-lightbox
            :visible="lightboxVisible"
            :imgs="[image]"
            :index="imgIndex"
            @hide="lightboxVisible = false"
        ></vue-easy-lightbox>
    </div>
</template>

<script>
import { reactive, toRefs } from 'vue'

import VueEasyLightbox from 'vue-easy-lightbox'

export default {

    props: [
        'image',
        'name',
        'badges'
    ],

    components: {
        VueEasyLightbox
    },

    setup() {

        const state = reactive({
            lightboxVisible: false,
            imgIndex: 0,
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
